import React from "react";
import { X } from "lucide-react";

const AddPrinterModal = ({ open, onClose, formData, onChange, onSubmit }) => {
  if (!open) return null;

  return (
    <div
      className="modal-backdrop"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="modal-content p-4"
        style={{
          background: "#f9f9f9ff",
          borderRadius: "12px",
          width: "400px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
          color: "black",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <X size={20} />
        </div>

        <h5 className="mb-3">Add New Printer</h5>

        <div className="mb-3">
          <label className="form-label">Printer Name</label>
          <input
            type="text"
            name="printerName"
            value={formData.printerName}
            onChange={onChange}
            className="form-control border-secondary"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Printer Alias</label>
          <input
            type="text"
            name="printerAlias"
            value={formData.printerAlias}
            onChange={onChange}
            className="form-control border-secondary"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Device Name</label>
          <input
            type="text"
            name="deviceName"
            value={formData.deviceName}
            onChange={onChange}
            className="form-control border-secondary"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Device No.</label>
          <input
            type="text"
            name="deviceNumber"
            value={formData.deviceNumber}
            onChange={onChange}
            className="form-control  border-secondary"
          />
        </div>

        <button className="blue-button w-100 mt-2" onClick={onSubmit}>
          Save Printer
        </button>
      </div>
    </div>
  );
};

export default AddPrinterModal;
